const ServicesList = () =>
	import(
		/* webpackChunkName: "serviceslist"*/ "@/views/ServicesList/index.vue"
	);
const ServicesEdit = () =>
	import(/* webpackChunkName: "servicesedit"*/ "@/views/ServicesEdit.vue");
const ServicesCreate = () =>
	import(
		/* webpackChunkName: "servicescreate"*/ "@/views/ServicesCreate.vue"
	);
const DataMapsList = () =>
	import(
		/* webpackChunkName: "datamapslist"*/ "@/views/DataMaps/List/index.vue"
	);
const DataMapsCreate = () =>
	import(
		/* webpackChunkName: "datamapscreate"*/ "@/views/DataMaps/Create.vue"
	);
const DataMapsAdvanced = () =>
	import(
		/* webpackChunkName: "datamapsadvanced"*/ "@/views/DataMaps/Advanced.vue"
	);
const DataMapsEdit = () =>
	import(/* webpackChunkName: "datamapsedit"*/ "@/views/DataMaps/Edit.vue");

export default [
	{
		path: "services",
		name: "ServicesList",
		component: ServicesList,
		meta: {
			title: "DailyAdmin - Supers services list"
		}
	},
	{
		path: "services/create",
		name: "ServicesCreate",
		component: ServicesCreate,
		meta: {
			title: "DailyAdmin - Services create"
		}
	},
	{
		path: "services/edit/:id",
		name: "ServicesEdit",
		component: ServicesEdit,
		meta: {
			title: "DailyAdmin - Services edit"
		}
	},
	// This will load the current users organisation (admin view)

	{
		path: "data-maps/create/:type?",
		name: "DataMapsCreate",
		component: DataMapsCreate,
		meta: {
			title: "DailyAdmin - Dashboard create"
		}
	},
	{
		path: "data-maps/edit/:id",
		name: "DataMapsEdit",
		component: DataMapsEdit,
		meta: {
			title: "DailyAdmin - Dashboard edit"
		}
	},
	{
		path: "data-maps/edit/:id/advanced",
		name: "DataMapsAdvanced",
		component: DataMapsAdvanced,
		meta: {
			title: "DailyAdmin - Dashboard advanced edit"
		}
	},
	{
		path: "data-maps/:type?",
		name: "DataMapsList",
		component: DataMapsList,
		meta: {
			title: "DailyAdmin - Super DataMaps list"
		}
	}
];
